<template>
  <div id="header">
    <div class="bg d-block d-md-none" />
    <img alt="x-bg" src="../assets/images/x-bg.png" class="x-bg d-block d-md-none" />
    <div class="container">
      <div class="button-container d-block d-md-none">
        <SecondaryButton @click="openOnepager" v-if="onePager">Onepager</SecondaryButton>
        <SecondaryButton @click="openWeb" v-if="web">Web</SecondaryButton>
      </div>
      <div class="row d-flex d-md-none">
        <button type="button" class="chevron-left" @click="goToHome()">
          <ChevronLeft />
        </button>
      </div>
      <div class="col-12">
        <div class="logo-box">
          <div class="row">
            <div class="col-12 col-md-8 order-md-2">
              <button type="button" class="icon times d-none d-md-block" @click="goToHome()">
                <Times />
              </button>
              <h1>{{name}}</h1>
              <div class="button-container d-none d-md-block">
                <SecondaryButton @click="openOnepager" v-if="onePager">Onepager</SecondaryButton>
                <SecondaryButton @click="openWeb" v-if="web">Web</SecondaryButton>
              </div>
            </div>
            <div class="col-12 col-md-4 order-md-1">
              <div class="logo-container">
                <div
                  class="logo"
                  :style="`background-image: url('${logo}');background-size:contain;background-position:center;`"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronLeft from '../assets/icons/chevron-left.svg';
import SecondaryButton from './Button/SecondaryButton.vue';
import Times from '../assets/icons/times-o.svg';

export default {
  name: 'StartupHeader',
  components: {
    ChevronLeft,
    SecondaryButton,
    Times,
  },
  props: {
    closeSidepanel: Function,
    onePager: String,
    web: String,
    name: String,
    logo: String,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    goToHome() {
      this.closeSidepanel();
    },
    openWeb() {
      window.open(this.web, '_blank');
    },
    openOnepager() {
      window.open(this.onePager, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
#header {
  width: 100%;
  overflow: hidden;
}
.button-container {
  float: right;
  text-align: right;
  transform: translate(22px, 28px);

  @media (min-width: 768px) {
    float: left;
    text-align: left;
    transform: translate(-5px, -5px);
  }
}
.chevron-left {
  position: relative;
  float: left;
  margin: 0;
  margin-top: 25px;
  margin-left: -5px;
  background: none;
  border: none;
  padding: 0;
  width: 34px;
}
.bg {
  width: 100%;
  height: 193px;
  background: #330e2f;
  border-radius: 0px 0px 30px 30px;
  position: absolute;
  top: 0;
  left: 0;
}

.logo {
  width: 80px;
  height: 80px;
  background-size: cover;
  background-repeat: no-repeat;
}
.logo-container {
  background: #fff;
  padding: 17px;
  overflow: hidden;
  width: fit-content;
  border-radius: 50%;
  margin: 0 auto;
  display: block;

  @media (min-width: 768px) {
    margin: 0;
    border: 1px solid #e5e5e5;
    padding: 8px;
  }
}
.logo-box {
  width: fit-content;
  text-align: center;
  margin: 0 auto;
  margin-top: 40px;

  @media (min-width: 768px) {
    width: 100%;
  }

  h1 {
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.376471px;
    text-transform: uppercase;
    color: #ffffff;

    @media (min-width: 768px) {
      color: #330e2f;
      text-align: left;
      margin-top: 20px;
    }
  }
}

.x-bg {
  position: absolute;
  right: -35px;
  top: 89px;
  max-height: 95px;
}

.icon {
  position: relative;
  float: left;
  margin: 0;
  margin-top: 25px;
  margin-left: -5px;
  background: none;
  border: none;
  padding: 0;
  width: 34px;
  cursor: pointer;

  &.times {
    margin: 0;
    right: 9px;
    top: 5px;
    position: absolute;
  }
}
</style>
